import {Swiper} from "swiper/bundle";

export default class TrumpSlider {
    constructor($slider) {
        const count = $slider.dataset.count;

        new Swiper(".mySwiper", {
            slidesPerView: window.innerWidth < 768 ? 1 : 3,
            spaceBetween: 0,
            watchSlidesProgress: true,
            pagination: {
                el: $slider.parentElement.querySelector('.swiper-pagination'),
                type: "bullets",
            },
            autoheight: false,
            loop: count > 1 ? true : false,
            navigation: {nextEl: ".trumps__next", prevEl: ".trumps__prev",},
        });
    }
}